<template>
  <div>
    <Head title="編輯免運活動" />
    <ScrollTop />

    <Breadcrumb :home="breadcrumb_home" :model="breadcrumb_paths" />

    <div class="w-full flex flex-row items-center justify-end gap-4">
      <Button
        label="儲存"
        @click="saveFreeShipping"
        :disabled="
          !(
            free_shipping.description &&
            (free_shipping.delivery_type.normal == true ||
              free_shipping.delivery_type.refrigerated == true ||
              free_shipping.delivery_type.frozen == true) &&
            (free_shipping.condition.type == 'always' ||
              (free_shipping.condition.type == 'greater' &&
                free_shipping.condition.amount > 0)) &&
            (free_shipping.duration.enabled == false ||
              (free_shipping.duration.enabled == true &&
                duration.start != null &&
                duration.end != null))
          )
        "
      />
    </div>

    <div class="border border-fh-gray-light mt-3 px-3">
      <div class="py-3">
        <div class="mt-1">
          <label for="description">活動名稱</label>
        </div>
        <div class="mt-1">
          <InputText
            id="description"
            v-model="free_shipping.description"
            class="w-full"
          />
        </div>
      </div>

      <div class="py-3">
        <div class="mt-1">
          <label for="description">運輸方式</label>
        </div>
        <div class="mt-1">
          <SelectButton v-model="free_shipping.delivery_method" :options="methods" optionLabel="name"
            optionValue="code" />
        </div>
      </div>

      <div class="py-3">
        <div class="mt-1">
          <label>適用商品</label>
        </div>
        <div class="mt-1">
          <div class="flex flex-row gap-4 items-center">
            <div class="flex flex-row items-center gap-2">
              <Checkbox
                id="delivery_normal"
                v-model="free_shipping.delivery_type.normal"
                :binary="true"
              />
              <label for="delivery_normal">常溫商品</label>
            </div>
            <div class="flex flex-row items-center gap-2">
              <Checkbox
                id="delivery_refrigerated"
                v-model="free_shipping.delivery_type.refrigerated"
                :binary="true"
              />
              <label for="delivery_refrigerated">冷藏商品</label>
            </div>
            <div class="flex flex-row items-center gap-2">
              <Checkbox
                id="delivery_frozen"
                v-model="free_shipping.delivery_type.frozen"
                :binary="true"
              />
              <label for="delivery_frozen">冷凍商品</label>
            </div>
          </div>
        </div>
      </div>

      <div class="py-3">
        <div class="mt-1">
          <label>選擇免運條件</label>
        </div>
        <div class="mt-1">
          <div class="flex flex-row gap-8">
            <SelectButton
              v-model="free_shipping.condition.type"
              :options="conditions"
              optionLabel="name"
              optionValue="code"
            />

            <div class="flex flex-row items-center gap-4">
              <label for="amount">消費金額超過</label>
              <InputNumber
                id="amount"
                mode="decimal"
                prefix="$"
                v-model="free_shipping.condition.amount"
                :disabled="free_shipping.condition.type != 'greater'"
                class="w-64"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="py-3">
        <div class="mt-1">
          <label>活動期間設定</label>
        </div>
        <div class="mt-1">
          <div class="flex flex-row gap-8">
            <SelectButton
              v-model="free_shipping.duration.enabled"
              :options="durations"
              optionLabel="name"
              optionValue="code"
            />

            <div class="flex flex-row items-center gap-4">
              <div>
                開始日期
                <Calendar
                  v-model="duration.start"
                  :maxDate="duration.end"
                  selectionMode="single"
                  :disabled="!free_shipping.duration.enabled"
                />
              </div>
              <div>
                結束日期
                <Calendar
                  v-model="duration.end"
                  :minDate="duration.start"
                  selectionMode="single"
                  :disabled="!free_shipping.duration.enabled"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from "../Layout";
import ScrollTop from "primevue/scrolltop";
import Breadcrumb from "@/Shared/Components/Breadcrumb";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Checkbox from "primevue/checkbox";
import SelectButton from "primevue/selectbutton";
import InputNumber from "primevue/inputnumber";
import Calendar from "primevue/calendar";

export default {
  layout: Layout,
  components: {
    ScrollTop,
    Breadcrumb,
    Button,
    InputText,
    Checkbox,
    SelectButton,
    InputNumber,
    Calendar,
  },
  props: {
    free_shipping: Object,
  },
  data() {
    return {
      breadcrumb_home: {
        label: "行銷管理",
        disabled: true,
      },
      breadcrumb_paths: [
        {
          label: "免運費",
          to: this.$page.props.from
            ? decodeURIComponent(atob(this.$page.props.from))
            : route("admin.free_shipping"),
        },
        {
          label: "新增活動",
          disabled: true,
        },
      ],
      conditions: [
        { name: "無條件", code: "always" },
        { name: "滿額", code: "greater" },
      ],
      durations: [
        { name: "永不過期", code: false },
        { name: "設定日期", code: true },
      ],
      duration: {
        start:
          this.free_shipping.duration.start == null
            ? null
            : new Date(this.free_shipping.duration.start),
        end:
          this.free_shipping.duration.end == null
            ? null
            : new Date(this.free_shipping.duration.end),
      },
      methods: [
        { name: "一般物流", code: 'regular' },
        { name: "711 店到店", code: '711' },
      ]
    };
  },
  methods: {
    saveFreeShipping() {
      let payload = {
        description: this.free_shipping.description,
        delivery_type: {
          normal: this.free_shipping.delivery_type.normal,
          refrigerated: this.free_shipping.delivery_type.refrigerated,
          frozen: this.free_shipping.delivery_type.frozen,
        },
        condition: {
          type: this.free_shipping.condition.type,
          amount:
            this.free_shipping.condition.type == "greater"
              ? this.free_shipping.condition.amount
              : 0,
        },
        duration: {
          enabled: this.free_shipping.duration.enabled,
          start: this.free_shipping.duration.enabled
            ? this.duration.start
            : null,
          end: this.free_shipping.duration.enabled ? this.duration.end : null,
        },
        delivery_method: this.free_shipping.delivery_method,
      };

      this.$inertia.post(
        route("admin.free_shipping.save", this.free_shipping.id),
        {
          payload: payload,
          to: this.$page.props.from
            ? decodeURIComponent(atob(this.$page.props.from))
            : route("admin.free_shipping"),
        }
      );
    },
  },
};
</script>

<style lang="postcss">
.p-breadcrumb {
  @apply border-0;
}
</style>